import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_STA033_Request,
  IAPI_STA033_Response,
  IAPI_STA034_Request,
  IAPI_STA034_Response,
} from "../../../type/apiType";

// 退職手当金追加支給参照
const httpAPI_STA034 = async (
  param: IAPI_STA034_Request
): Promise<IAPI_STA034_Response> => {
  let res = await http.post(ApiUrl.API_STA034, {
    ...param,
  });

  return res.data;
};

// 退職手当金追加支給更新
const httpAPI_STA033 = async (
  param: IAPI_STA033_Request
): Promise<IAPI_STA033_Response> => {
  let res = await http.post(ApiUrl.API_STA033, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA034, httpAPI_STA033, httpAPI_APP016 };
